import { Outlet, createFileRoute } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";

import { PlaceProfileHeader } from "./-components/PlaceProfileHeader";

export const Route = createFileRoute("/_staff/places/$id/_layout")({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <PlaceProfileHeader />
      <Outlet />
    </VStack>
  );
}
